export interface Testimonial {
  id: number;
  name: string;
  avatar: string;
  rating: number;
  content: string;
  date: string;
}

export const testimonials: Testimonial[] = [
  {
    id: 1,
    name: '漫画迷小王',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20young%20man%20profile%20photo%2C%20casual%20style%2C%20warm%20smile%2C%20simple%20studio%20background%2C%20soft%20lighting%2C%20clean%20portrait&width=200&height=200&seq=avatar-01&orientation=squarish',
    rating: 5,
    content: '虚空韩漫网的更新速度真的没话说！我是《暗夜追踪者》的忠实粉丝，每次更新都能第一时间在这里看到。画质清晰，加载速度也很快，强烈推荐给所有韩漫爱好者！',
    date: '2026-07-01',
  },
  {
    id: 2,
    name: '追漫少女',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20young%20woman%20profile%20photo%2C%20cute%20smile%2C%20casual%20fashion%2C%20simple%20studio%20background%2C%20soft%20warm%20lighting%2C%20clean%20portrait&width=200&height=200&seq=avatar-02&orientation=squarish',
    rating: 5,
    content: '在这里发现了超多好看的恋爱韩漫！《她的逆袭》和《我的同桌是狐仙》简直是神作！分类也很清晰，找漫画超方便。每天必刷的网站，已经安利给身边所有朋友了。',
    date: '2026-06-28',
  },
  {
    id: 3,
    name: '资深读者老李',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20middle%20aged%20man%20profile%20photo%2C%20glasses%2C%20warm%20expression%2C%20simple%20studio%20background%2C%20soft%20lighting%2C%20clean%20professional%20portrait&width=200&height=200&seq=avatar-03&orientation=squarish',
    rating: 5,
    content: '看了十年韩漫，虚空韩漫网是我见过最良心的平台。漫画种类齐全，从恋爱到悬疑应有尽有。最赞的是完全没有烦人的广告弹窗，阅读体验一流！',
    date: '2026-06-25',
  },
];